export type DocumentVerrouType = "bon_commande" | "bon_livraison" | "facture_fournisseur";

/**
 * `reception` : un magasinier a le document ouvert dans une réception (partagé entre magasiniers).
 * `modification` : l'administrateur le corrige (exclusif).
 */
export type DocumentVerrouMode = "reception" | "modification";

export interface DocumentVerrou {
	id: number;
	documentId: number;
	mode: DocumentVerrouMode;
	user: { id: number; nom: string } | null;
	depuis: string;
	expireLe: string;
	/** Le verrou est celui de l'utilisateur connecté : il ne le bloque pas. */
	estMoi: boolean;
}

export interface VerrouRefuse {
	documentId: number;
	verrous: DocumentVerrou[];
}

export interface AcquisitionVerrous {
	acquis: number[];
	/** Documents tenus par quelqu'un d'autre dans un mode incompatible. */
	refuses: VerrouRefuse[];
	dureeMs: number;
}

const heure = (date: string) => new Date(date).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });

/** « en cours de réception par Rachid (depuis 10:32) » */
export const decrireVerrou = (verrou: DocumentVerrou): string =>
	`en cours de ${verrou.mode === "reception" ? "réception" : "modification"} par ${verrou.user?.nom || "un autre utilisateur"} (depuis ${heure(verrou.depuis)})`;

export const decrireVerrous = (verrous: DocumentVerrou[]): string => verrous.map(decrireVerrou).join(", ");
